module.exports = "/layout/app/images/bg-section-check-for-new-extensions-before.d6c453ae.svg";